<p-fileUpload
  #fileUpload
  mode="basic"
  [multiple]="multiple"
  [customUpload]="true"
  [auto]="true"
  [styleClass]="styleClass"
  [accept]="accept"
  [maxFileSize]="maxFileSize"
  (uploadHandler)="uploadFiles($event.files)"
  [disabled]="uploadingFiles || disabled"
  [chooseIcon]="uploadingFiles ? 'pi-spin pi-spinner' : icon"
  [chooseLabel]="uploadingFiles ? uploadingLabel : label">
</p-fileUpload>
